<template>
    <div class="row" v-if="isValid('CanViewPromotionOffer')">
        <div class="col-lg-12 col-sm-12" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'arabicLanguage'">
            <div class="row mb-4">
                <div class="col-lg-12">
                    <h5 class="page_title">{{ $t('Promotion.Promotion') }}</h5>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="#">{{ $t('Promotion.Home') }}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{{ $t('Promotion.Promotion') }}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('Promotion.SearchbyOfferName') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('Promotion.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a href="javascript:void(0)" v-bind:disabled="activePromotion>=3" class="btn btn-primary" style="margin-top:27px;" v-if="isValid('CanAddPromotionOffer')" v-on:click="AddPromotion"><i class="fa fa-plus"></i>  {{ $t('Promotion.AddNew') }}</a>

                            <router-link :to="'/StartScreen'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger" style="margin-top:27px;">{{ $t('Promotion.Close') }} </a>
                            </router-link>
                        </div>
                        <div class="col-lg-12">
                            <div>
                                <ul class="nav nav-tabs" data-tabs="tabs">
                                    <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Active'}" v-on:click="makeActive('Active')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">   {{ $t('Promotion.Active') }}</a></li>
                                    <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'History'}" v-on:click="makeActive('History')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">{{ $t('Promotion.History') }}</a></li>
                                </ul>
                            </div>
                            <div class="tab-content mt-3" id="nav-tabContent">
                                <div v-if="active == 'Active'">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-striped table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                {{ $t('Promotion.ID') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.OFFER_NAME') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.ProductName') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.FIXED_DISCOUNT') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.DiscountPercentage') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.Quantity') }}
                                                            </th>

                                                            <th>
                                                                {{ $t('Promotion.FromDate') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.ToDate') }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(details, index) in promotionList" v-bind:key="details.id">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <td v-if="isValid('CanEditPromotionOffer')">
                                                                <strong>
                                                                    <a href="javascript:void(0)" v-on:click="EditPromotionInfo(details.id)">{{details.offer}}</a>
                                                                </strong>
                                                            </td>
                                                            <td v-else>
                                                                {{details.offer}}
                                                            </td>
                                                            <td>{{details.productName}}</td>
                                                            <td>{{details.fixedDiscount}}</td>
                                                            <td>{{details.discountPercentage}}</td>
                                                            <td>{{details.quantity}}</td>

                                                            <td>{{details.fromDate}}</td>
                                                            <td>{{details.toDate}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="active == 'History'">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-striped table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                {{ $t('Promotion.ID') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.OFFER_NAME') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.ProductName') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.FIXED_DISCOUNT') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.DiscountPercentage') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.Quantity') }}
                                                            </th>

                                                            <th>
                                                                {{ $t('Promotion.FromDate') }}
                                                            </th>
                                                            <th>
                                                                {{ $t('Promotion.ToDate') }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(details, index) in promotionList" v-bind:key="details.id">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <td>
                                                                {{details.offer}}
                                                            </td>
                                                            <td>{{details.productName}}</td>
                                                            <td>{{details.fixedDiscount}}</td>
                                                            <td>{{details.discountPercentage}}</td>
                                                            <td>{{details.quantity}}</td>

                                                            <td>{{details.fromDate}}</td>
                                                            <td>{{details.toDate}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        name: 'Promotion',
        mixins: [clickMixin],
        data: function () {
            return {
                show: false,
                promotionList: [],
                active: 'Active',
                search: '',
                searchQuery: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                activePromotion: 0
            }
        },
        watch: {
            search: function (val) {
                this.getData(val, 1, this.active);
            }
        },
        methods: {
            AddPromotion: function () {
                this.$router.push('/AddPromotion')
            },
            getPage: function () {
                this.getData(this.search, this.currentPage, this.active);
            },
            makeActive: function (item) {
                this.active = item;
                this.getData(this.search, 1, item);
            },
            getData: function (search, currentPage, status) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/GetPromotion?status=' + status + '&searchTerm=' + search + '&pageNumber=' + currentPage, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {

                        if (response.data != null) {
                            root.promotionList = response.data.results;
                            root.activePromotion = response.data.activeBundle;
                            root.pageCount = response.data.pageCount;
                            root.rowCount = response.data.rowCount;
                        }
                    });
            },

            EditPromotionInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/PromotionDetailsViaId?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.$router.push({
                            path: '/AddPromotion',
                            query: { data: response.data }
                        })
                    }
                });

            }
        },
        created: function () {

            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.makeActive("Active");
        }
    }
</script>